import React, {useState} from 'react';
import styles from './pageForAddInfo.module.css';

const formFieldsRSBU = [
  {name: "ticker", label: "Тикер"},
  {name: "report_type", label: "Тип отчета"},
  {name: "date", label: "Дата"},

  // Ratios: KeyStats
  {name: "inputs/incomeStatement/Revenue/revenue/date", label: "Дата дохода"},
  {name: "inputs/incomeStatement/Revenue/revenue/value", label: "Значение дохода"},
  {name: "inputs/incomeStatement/Revenue/cost_of_production/date", label: "Дата себестоимости"},
  {name: "inputs/incomeStatement/Revenue/cost_of_production/value", label: "Значение себестоимости"},

  // IncomeStatement: OperationIncomeAndExpenses
  {name: "inputs/incomeStatement/OperationIncomeAndExpenses/operating_income/date", label: "Дата операционной прибыли"},
  {name: "inputs/incomeStatement/OperationIncomeAndExpenses/operating_income/value", label: "Значение операционной прибыли"},
  {name: "inputs/incomeStatement/OperationIncomeAndExpenses/opex/date", label: "Дата операционных расходов"},
  {name: "inputs/incomeStatement/OperationIncomeAndExpenses/opex/value", label: "Значение операционных расходов"},

  // BalanceSheet: LongTermAssets
  {name: "inputs/balanceSheet/LongTermAssets/assets/date", label: "Дата долгосрочных активов"},
  {name: "inputs/balanceSheet/LongTermAssets/assets/value", label: "Значение долгосрочных активов"},

  // BalanceSheet: CommonEquity
  {name: "inputs/balanceSheet/CommonEquity/equity/date", label: "Дата собственного капитала"},
  {name: "inputs/balanceSheet/CommonEquity/equity/value", label: "Значение собственного капитала"},

  // CashFlow: CashFlowFromOperations
  {name: "inputs/cashFlow/CashFlowFromOperations/ocf/date", label: "Дата операционного денежного потока"},
  {name: "inputs/cashFlow/CashFlowFromOperations/ocf/value", label: "Значение операционного денежного потока"},

  // Ratios: KeyStats
  {name: "inputs/ratios/KeyStats/eps/date", label: "Дата EPS"},
  {name: "inputs/ratios/KeyStats/eps/value", label: "Значение EPS"}
];

const formFieldsMFSO = [
  {name: "ticker", label: "Тикер"},
  {name: "report_type", label: "Тип отчета"},
  {name: "date", label: "Дата"},

  // Ratios: KeyStats
  {name: "inputs/ratios/KeyStats/type", label: "Тип (Ключевые показатели)"},
  {name: "inputs/ratios/KeyStats/value", label: "Значение (Ключевые показатели)"},
  {name: "inputs/ratios/KeyStats/change", label: "Изменение (Ключевые показатели)"},
  {name: "inputs/ratios/KeyStats/parameter", label: "Параметр (Ключевые показатели)"},
  {name: "inputs/ratios/KeyStats/change_YoY", label: "Изменение год к году (Ключевые показатели)"},

  // CashFlow: Supplemental
  {name: "inputs/cashFlow/Supplemental/value", label: ""},
  {name: "inputs/cashFlow/Supplemental/change", label: ""},
  {name: "inputs/cashFlow/Supplemental/parameter", label: ""},

  // CashFlow: CashFlowFromInvesting
  {name: "inputs/cashFlow/CashFlowFromInvesting/value", label: "Значение (Инвестиционный денежный поток)"},
  {name: "inputs/cashFlow/CashFlowFromInvesting/change", label: "Изменение (Инвестиционный денежный поток)"},
  {name: "inputs/cashFlow/CashFlowFromInvesting/parameter", label: "Параметр (Инвестиционный денежный поток)"},

  // CashFlow: CashFlowFromOperations
  {name: "inputs/cashFlow/CashFlowFromOpetaions/value", label: "Значение (Операционный денежный поток)"},
  {name: "inputs/cashFlow/CashFlowFromOpetaions/change", label: "Изменение (Операционный денежный поток)"},
  {name: "inputs/cashFlow/CashFlowFromOpetaions/parameter", label: "Параметр (Операционный денежный поток)"},

  // BalanceSheet: CommonEquity
  {name: "inputs/balanceSheet/CommonEquity/value", label: "Значение (Собственный капитал)"},
  {name: "inputs/balanceSheet/CommonEquity/change", label: "Изменение (Собственный капитал)"},
  {name: "inputs/balanceSheet/CommonEquity/parameter", label: "Параметр (Собственный капитал)"},

  // BalanceSheet: Supplemental
  {name: "inputs/balanceSheet/Supplemental/value", label: ""},
  {name: "inputs/balanceSheet/Supplemental/change", label: ""},
  {name: "inputs/balanceSheet/Supplemental/parameter", label: ""},

  // BalanceSheet: LongTermAssets
  {name: "inputs/balanceSheet/LongTermAssets/value", label: "Значение (Долгосрочные активы)"},
  {name: "inputs/balanceSheet/LongTermAssets/change", label: "Изменение (Долгосрочные активы)"},
  {name: "inputs/balanceSheet/LongTermAssets/parameter", label: "Параметр (Долгосрочные активы)"},

  // BalanceSheet: LongTermLiabilities
  {name: "inputs/balanceSheet/LongTermLiabilities/value", label: "Значение (Долгосрочные обязательства)"},
  {name: "inputs/balanceSheet/LongTermLiabilities/change", label: "Изменение (Долгосрочные обязательства)"},
  {name: "inputs/balanceSheet/LongTermLiabilities/parameter", label: "Параметр (Долгосрочные обязательства)"},

  // BalanceSheet: CashAndShortTermInvestments
  {name: "inputs/balanceSheet/CashAndShortTermInvestments/value", label: "Значение (Денежные средства и краткосрочные инвестиции)"},
  {name: "inputs/balanceSheet/CashAndShortTermInvestments/change", label: "Изменение (Денежные средства и краткосрочные инвестиции)"},
  {name: "inputs/balanceSheet/CashAndShortTermInvestments/parameter", label: "Параметр (Денежные средства и краткосрочные инвестиции)"},

  // IncomeStatement: Revenue
  {name: "inputs/incomeStatement/Revenue/revenue/date", label: "Дата дохода"},
  {name: "inputs/incomeStatement/Revenue/revenue/value", label: "Значение дохода"},
  {name: "inputs/incomeStatement/Revenue/cost_of_production/date", label: "Дата себестоимости"},
  {name: "inputs/incomeStatement/Revenue/cost_of_production/value", label: "Значение себестоимости"},

  // IncomeStatement: NetIncome
  {name: "inputs/incomeStatement/NetIncome/value", label: "Значение (Чистая прибыль)"},
  {name: "inputs/incomeStatement/NetIncome/change", label: "Изменение (Чистая прибыль)"},
  {name: "inputs/incomeStatement/NetIncome/parameter", label: "Параметр (Чистая прибыль)"},

  // IncomeStatement: Supplemental
  {name: "inputs/incomeStatement/Supplemental/value", label: ""},
  {name: "inputs/incomeStatement/Supplemental/change", label: ""},
  {name: "inputs/incomeStatement/Supplemental/parameter", label: ""},

  // IncomeStatement: EarningsFromContOperations
  {name: "inputs/incomeStatement/EarningsFromContOperations/value", label: "Значение (Доходы от непрерывных операций)"},
  {name: "inputs/incomeStatement/EarningsFromContOperations/change", label: "Изменение (Доходы от непрерывных операций)"},
  {name: "inputs/incomeStatement/EarningsFromContOperations/parameter", label: "Параметр (Доходы от непрерывных операций)"},

  // IncomeStatement: OperationIncomeAndExpenses
  {name: "inputs/incomeStatement/OperationIncomeAndExpenses/value", label: "Значение (Операционные доходы и расходы)"},
  {name: "inputs/incomeStatement/OperationIncomeAndExpenses/change", label: "Изменение (Операционные доходы и расходы)"},
  {name: "inputs/incomeStatement/OperationIncomeAndExpenses/parameter", label: "Параметр (Операционные доходы и расходы)"}
];

const formFieldsDividends = [
  {name: "ticker", label: "Тикер"},
  {name: "date", label: "Дата"},

  {name: "inputs/amount", label: "Сумма"},
  {name: "inputs/period", label: "Период"},
  {name: "inputs/status", label: "Статус"},
  {name: "inputs/declareDate", label: "Дата объявления"},
  {name: "inputs/paymentDate", label: "Дата выплаты"},
  {name: "inputs/lastPurchaseDate", label: "Дата последней покупки"}
];

const forms = [
  {
    url: "/api/financial-data/update-data-msfo/",
    label: "МФСО",
    fields: formFieldsMFSO,
  },
  {
    url: "/api/financial-data/update-data-rsbu/",
    label: "РСБУ",
    fields: formFieldsRSBU
  },
  {
    url: "/api/financial-data/update-data-dividends/",
    label: "Дивиденды",
    fields: formFieldsDividends
  }
];


const PageForAddInfo = () => {
  const [selectedForm, setSelectedForm] = useState(forms[0]);

  const [statusCode, setStatusCode] = useState();

  function handleSubmit(event) {
    event.preventDefault();

    const inputs = event.target.querySelectorAll('input');
    const formData = {};

    inputs.forEach(input => {
      // Разделяем name по '/' чтобы создать вложенную структуру объекта
      const keys = input.name.split('/');
      let current = formData;

      // Проходим по всем ключам, кроме последнего, создаем вложенные объекты
      keys.forEach((key, index) => {
        if (index === keys.length - 1) {
          // На последнем ключе присваиваем значение
          current[key] = input.value;
        } else {
          // Если объект по ключу не существует, создаем его
          if (!current[key]) {
            current[key] = {};
          }
          current = current[key];
        }
      });
    });

    if(selectedForm.label === "Дивиденды" && formData.inputs) formData.inputs = [formData.inputs];

    const token = localStorage.getItem('token');

    fetch(selectedForm.url, {
      headers: {
        "Content-Type": "application/json",
        "Authorization": `Token ${token}`
      },
      method: 'PATCH',
      body: JSON.stringify(formData)
    })
      .then(res => {
        setStatusCode(res.status);
      });
  }

  return (
    <div className={styles.container}>
      <div className={styles.formTypeSelector}>
        {forms.map((form) => (
          <label key={form.url}>
            <input
              type="radio"
              name="formSelect"
              checked={selectedForm.url === form.url}
              onChange={() => setSelectedForm(form)}
            />
            <span className={styles.label}>{form.label}</span>
          </label>
        ))}
      </div>

      <form onSubmit={handleSubmit}>
        {selectedForm.fields.map(field => (
          <label className={styles.textField} key={field.name + selectedForm.url}>
            <input className={styles.input} type="text" name={field.name} {...field?.params}/>
            <span className={styles.label}>{field.label || field.name}</span>
          </label>
        ))}
        <button className={styles.button}>Сохранить</button>
        {statusCode && <p className={styles.statusCode}>Статус код: {statusCode}</p>}
      </form>
    </div>
  )
};

export default PageForAddInfo;
